export type TextEditorProps = {
  placeholder: string;
  maxLength: number;
  content?: string;
  ariaLabel: string;
  boldAriaLabel: string;
  underlineAriaLabel: string;
  italicAriaLabel: string;
  toolbarOptions: EditorProperties;
  onChange: (htmlText: string, plainText: string) => void;
};

export type EditorProperties = {
  alignOptions: {
    key: string;
    label: string;
  }[];
  fontStyleOptions: {
    key: string;
    label: string;
  }[];
  linkOptions: {
    title: string;
    pathLabel: string;
    placeholder: string;
    ariaLabel: string;
    cancelLabel: string;
    submitLabel: string;
  };
};

export enum TextAlignOptions {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
}

export enum FontStyleOptions {
  PARAGRAPH = 'p',
  HEADING2 = 'h2',
  HEADING4 = 'h4',
}
